import { ANONYMOUS_USER_ID_KEY } from "../../lib/constants";

const uuidLikePattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isValidAnonymousUserId(value: string) {
  return uuidLikePattern.test(value);
}

export function createAnonymousUserId() {
  if (!globalThis.crypto?.randomUUID) {
    const fallback = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (char) =>
      (Number(char) ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (Number(char) / 4)))).toString(16)
    );
    return fallback;
  }

  return crypto.randomUUID();
}

export function getAnonymousUserId() {
  const existing = localStorage.getItem(ANONYMOUS_USER_ID_KEY);
  if (existing && isValidAnonymousUserId(existing)) {
    return existing;
  }

  const next = createAnonymousUserId();
  localStorage.setItem(ANONYMOUS_USER_ID_KEY, next);
  return next;
}

export function resetAnonymousUserId() {
  const next = createAnonymousUserId();
  localStorage.setItem(ANONYMOUS_USER_ID_KEY, next);
  return next;
}

export function getMaskedAnonymousUserId() {
  const id = getAnonymousUserId();
  return `${id.slice(0, 8)}...${id.slice(-6)}`;
}
